import type { FormElement } from '@common';
import { FormElementPlugin } from '@common';
import { getUpkeepCostHint } from '../utils/decision-support.utils';

export class UpkeepCostHintChangePlugin extends FormElementPlugin {
  public constructor() {
    super();
    this._name = 'upkeepCostChange';
  }

  public override onValueChange(element: FormElement<any>) {
    if (element.settings.custom) {
      const area = element.settings.custom.area as number;
      const translatedText = element.settings.custom.translatedText as string;
      element.attributes.hint = getUpkeepCostHint(translatedText, area, element.value);
    }
  }
}
